<template>
  <v-layout row wrap>
    <v-flex lg4 md4>
      <v-layout row wrap>
        <v-flex lg1 md1>
          <v-btn :depressed="true" fab round small @click="back()" color="primary"><v-icon>navigate_before</v-icon></v-btn>
        </v-flex>
        <v-flex lg3 md3 style="margin-top: 6px">
          <v-btn to="/" color="error" :depressed="true" round small flat>I Want to start over</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'front-navigation',
  data () {
    return {}
  },
  methods: {
    back: function () {
      return this.$router.back()
    },
    forward: function () {
      return this.$router.forward()
    }
  }
}
</script>

<style scoped>
  @-webkit-keyframes blink {
    from {
      opacity: 1.0;
    }
    to {
      opacity: 0.0;
    }
  }
  .blink {
    -webkit-animation-name: blink;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: cubic-bezier(1.0, 0, 0, 1.0);
    -webkit-animation-duration: 10s;
  }
</style>
